import React, { useState } from "react";
import "./ContactSection.css";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaTwitter, FaPaperPlane } from "react-icons/fa";

export default function ContactSection() {
  const [active, setActive] = useState("Event");

  const options = ["Event", "Package", "Menu", "Sound system", "Other"];

  return (
    <section className="contact-section">
      <div className="contact-container">

        {/* LEFT SIDE */}
        <div className="contact-left">
          <h2>
            Let’s discuss <br />
            on something <span>cool</span><br />
            together
          </h2>

          <div className="contact-info">
            <p><FaEnvelope /> demo@gmail.com</p>

            <div className="phone-box">
              <FaPhone />
              <span>+123 456 789</span>
            </div>

            <p><FaMapMarkerAlt /> 123 Street 456 House</p>

            <div className="social-icons">
              <FaFacebookF />
              <FaInstagram className="active-icon" />
              <FaTwitter />
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="contact-right">

          <p className="query-title">I’m have querry in...</p>

          <div className="query-options">
            {options.map((item) => (
              <button
                key={item}
                className={active === item ? "active" : ""}
                onClick={() => setActive(item)}
              >
                {item}
              </button>
            ))}
          </div>

          <div className="form-fields1">
            <input type="text" placeholder="Your name" />
            <input type="email" placeholder="Your email" />
            <textarea placeholder="Your message"></textarea>
          </div>

          <button className="send-btn">
            <FaPaperPlane /> Send Message
          </button>

        </div>

      </div>
    </section>
  );
}